import React from 'react';
import { View, Text } from 'react-native';
import { LinearGradient } from 'expo-linear-gradient';
import i18n from 'i18n-js';
import globalStyles from '../style/global';
import commonStyles from '../style/commonStyles';

const DisplaySerialRecordingNote = ({ item, name }) => {
  if (!item) return null;
  const recordSerial = item.record_serial === true;
  const recordSecondSerial = item.second_record_serial === true;
  if (!recordSerial && !recordSecondSerial) return null;

  const message =
    recordSerial && recordSecondSerial
      ? i18n.t('nextItems.serialRecordingNoteTwo')
      : i18n.t('nextItems.serialRecordingNote');

  return (
    <LinearGradient
      dataSet={{ componentName: name }}
      locations={[0, 0.13, 1]}
      colors={['#000000', '#fdf359', '#d2c609']}
      style={globalStyles.nextItemNotes}
    >
      <View style={{ width: '100%' }}>
        <Text style={commonStyles.nextItemText}>{message}</Text>
      </View>
    </LinearGradient>
  );
};

export default DisplaySerialRecordingNote;
